export default __webpack_public_path__ + "static/media/a1.63f3ee4a.png";